module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/routes/performance/performance-sponsors/performance-sponsors.component.scss
// module id = ./src/app/routes/performance/performance-sponsors/performance-sponsors.component.scss
// module chunks = 9